module.exports = __webpack_public_path__ + "media/images/shared/delivery/azimut-7f7146f48362de53364321bef0eec1ad.png";